import { useEffect } from 'react';
import { API_BASE_URL } from '../constants';

const useDataFetcher = ({
    setLoading,
    setCharacters,
    setAllCards,
    setAllStats,
    setAllAptitudes,
    setAllSkills,
    setSelectedCharacter
}) => {
    useEffect(() => {
        document.body.className = 'bg-panel-gray font-sans';
        async function fetchData() {
            try {
                setLoading(true);

                const headers = {};

                const requestOptions = { headers };

                const [charsRes, cardsRes, statsRes, aptsRes, skillsRes] = await Promise.all([
                    fetch(`${API_BASE_URL}/characters`, requestOptions),
                    fetch(`${API_BASE_URL}/cards`, requestOptions),
                    fetch(`${API_BASE_URL}/stats`, requestOptions),
                    fetch(`${API_BASE_URL}/aptitudes`, requestOptions),
                    fetch(`${API_BASE_URL}/skills`, requestOptions),
                ]);

                const charactersData = await charsRes.json();
                const cardsData = await cardsRes.json();
                const statsData = await statsRes.json();
                const aptitudesData = await aptsRes.json();
                const skillsData = await skillsRes.json();

                // Filter out NPCs for the main app
                const playableCharacters = charactersData.filter(c => c.Player_type !== 'NPC');

                setCharacters(playableCharacters);
                setAllCards(cardsData);
                setAllStats(statsData);
                setAllAptitudes(aptitudesData);
                setAllSkills(skillsData);

                if (playableCharacters.length > 0) {
                    setSelectedCharacter(playableCharacters[0]);
                }
            } catch (error) {
                console.error("Failed to fetch data:", error);
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [setLoading, setCharacters, setAllCards, setAllStats, setAllAptitudes, setAllSkills, setSelectedCharacter]); // Dependencies added to satisfy linter
};

export default useDataFetcher;
// Revisado: 2025-12-16
